<template>
  <div id="editorial-office-submissions-other-author">
    <div class="ipub-h1 mar-b-30 relative">
      Author(s) - Manuscript No: {{articleDetail.code}}
      <div class="right-option ipub-p1"
           v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.VIEW_ALL_AUTHOR_DETAILS.SEND_LETTERS')">
        <ipub-button type="primary"
                     :disabled="articleDetail.signList[0] !== articleDetail.sign"
                     @click="sendLetter()">
          Send Letters
        </ipub-button>
      </div>
    </div>
    <div class="page-content">
      <div class="line-h-40 mar-b-10 ipub-h3 ipub-title-tab">Submitted Author</div>
      <ipub-table :columns="authorColumns"
                  :pagination="false"
                  :dataSource="author">
        <template v-slot:name="{record}">
          <ipub-tooltip style="width:100%">
            <div slot="title">{{record.firstName}} {{record.lastName}}</div>
            <div class="omission-2">
              <font class="key-color"
                    v-if="record.corresponded">*</font>{{record.firstName}} {{record.lastName}}
            </div>
          </ipub-tooltip>
        </template>
        <template v-slot:email="{text,record}">
          <ipub-tooltip style="width:100%">
            <div slot="title">{{text}} <font v-if="record.submitter">({{record.submitter && record.submitter.email}})</font>
            </div>
            <div class="omission-2">
              {{text}}<font v-if="record.submitter">({{record.submitter && record.submitter.email}})</font>
            </div>
          </ipub-tooltip>
        </template>
        <template v-slot:country="{text}">
          <ipub-tooltip style="width:100%">
            <div slot="title">{{country[text]}}</div>
            <div class="omission-2">{{country[text]}}</div>
          </ipub-tooltip>
        </template>
        <template v-slot:orcid="{text}">
          <div v-if="text"
               class="omission-2">
            <a class="link-color"
               target="_blank"
               :href="`https://orcid.org/${text}`">{{text}}</a>
          </div>
          <div v-else>--</div>
        </template>
      </ipub-table>
    </div>
    <div class="page-content">
      <div class="line-h-40 ipub-h3 mar-b-10 ipub-title-tab">Co-Author(s)</div>
      <ipub-table :columns="columns"
                  :pagination="false"
                  :dataSource="dataSource">
        <template v-slot:checkbox="{record}">
          <ipub-radio :checked="selectList.includes(record.id)"
                      :disabled="record.status!=='NO_RESPONSE'"
                      @change="onSelectChange(record.id)"
                      checkBox />
        </template>
        <template v-slot:name="{record}">
          <ipub-tooltip style="width:100%">
            <div slot="title">{{record.firstName}} {{record.lastName}}</div>
            <div class="omission-2">
              <font class="key-color"
                    v-if="record.corresponded">*</font>{{record.firstName}} {{record.lastName}}
            </div>
          </ipub-tooltip>
        </template>
        <template v-slot:email="{text,record}">
          <ipub-tooltip style="width:100%">
            <div slot="title">{{text}} <font v-if="record.submitter">({{record.submitter && record.submitter.email}})</font>
            </div>
            <div class="omission-2">
              {{text}}<font v-if="record.submitter">({{record.submitter && record.submitter.email}})</font>
            </div>
          </ipub-tooltip>
        </template>
        <template v-slot:country="{text}">
          <ipub-tooltip style="width:100%">
            <div slot="title">{{country[text]}}</div>
            <div class="omission-2">{{country[text]}}</div>
          </ipub-tooltip>
        </template>
        <template v-slot:orcid="{text}">
          <div v-if="text"
               class="omission-2">
            <a class="link-color"
               target="_blank"
               :href="`https://orcid.org/${text}`">{{text}}</a>
          </div>
          <div v-else>--</div>
        </template>
        <template v-slot:status="{text, record}">
          <div :class="text==='DECLINED'?'key-color':''">
            {{AUTHOR_STATUS[text]}}
            <div>{{record.statusTime?$moment(record.statusTime).format('DD / MM / YYYY'):'- -'}}</div>
          </div>
        </template>
        <template v-slot:actions="{ record }">
          <template v-if="record.status==='NO_RESPONSE'">
            <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.VIEW_ALL_AUTHOR_DETAILS.SEND_LETTERS')">
              <ipub-tooltip>
                <div slot="title">Resend Letter</div>
                <ipub-icon v-if="articleDetail.signList[0] === articleDetail.sign"
                           type="iconSend"
                           @click="sendLetter(record)" />
                <ipub-icon v-else
                           class="disabled-icon"
                           type="iconSend" />
              </ipub-tooltip>
            </template>

          </template>
          <template v-else>
            <ipub-tooltip class="border-right"
                          v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.VIEW_ALL_AUTHOR_DETAILS.RESET_CONFIRMATION_STATUS')">
              <div slot="title">Reset Confirmation Status</div>
              <ipub-icon v-if="articleDetail.signList[0] === articleDetail.sign"
                         type="icona-BacktoAuthor"
                         @click="reset(record)" />
              <ipub-icon v-else
                         class="disabled-icon"
                         type="icona-BacktoAuthor" />
            </ipub-tooltip>
          </template>
          <ipub-tooltip v-if="record.status==='CONFIRMED'">
            <div slot="title">View Questionnaire Responses</div>
            <ipub-icon type="iconViewDetails"
                       @click="viewQuestionnaire(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <div>
      <ipub-button plain
                   style="width:230px"
                   @click="() => { $router.back(-1)}"
                   type="primary">Back</ipub-button>
    </div>
    <AuthorQuestionnaire :isVisable="showAuthorQuestionnaire"
                         :inputData="inputData"
                         @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
